import { c as _c } from "react/compiler-runtime";
import { menuData } from "@/data/MenuData";
import DesktopNav from "../common/navigation/DesktopNav";
import MobileNav from "../common/navigation/MobileNav";
interface NavMenuProps {
  scrolled: boolean;
  isMobileOpen: boolean;
  onMobileToggle: () => void;
  onMobileClose: () => void;
}
const NavMenu = t0 => {
  const $ = _c(9);
  const {
    scrolled,
    isMobileOpen,
    onMobileToggle,
    onMobileClose
  } = t0;
  let t1;
  if ($[0] !== scrolled) {
    t1 = <DesktopNav menuItems={menuData.navMenu} scrolled={scrolled} />;
    $[0] = scrolled;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isMobileOpen || $[3] !== onMobileClose || $[4] !== onMobileToggle) {
    t2 = <MobileNav menuItems={menuData.navMenu} isOpen={isMobileOpen} onToggle={onMobileToggle} onClose={onMobileClose} />;
    $[2] = isMobileOpen;
    $[3] = onMobileClose;
    $[4] = onMobileToggle;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default NavMenu;